var MDB = window.MDB || {};
MDB.GDPR = MDB.GDPR || {};
MDB.GDPR.Sites = MDB.GDPR.Sites || {};

$.extend(MDB.GDPR.Sites, {
    bootIndex: function () {
        MDB.GDPR.Sites.bindPromptButtons('.requires-confirm');
    }
});